/* eslint-disable camelcase */
// theme constant
import eco2 from "../../assets/images/indicators/eco2.jpg";
import eco3 from "../../assets/images/indicators/eco3.jpg";
import water2 from "../../assets/images/indicators/water2.jpg";
import water3 from "../../assets/images/indicators/water3.jpg";
import agriculture3 from "../../assets/images/indicators/agriculture3.jpg";
import agriculture2 from "../../assets/images/indicators/agriculture2.jpg";
//
// export const CountryFlags = [
//   { Country: "Afghanistan", FlagUrl: "https://flagcdn.com/h120/af.webp" },
//   { Country: "Bangladesh", FlagUrl: "https://flagcdn.com/h120/bd.webp" },
//   { Country: "Bhutan", FlagUrl: "https://flagcdn.com/h120/bt.webp" },
//   { Country: "China", FlagUrl: "https://flagcdn.com/h120/cn.webp" },
//   { Country: "India", FlagUrl: "https://flagcdn.com/h120/in.webp" },
//   { Country: "Myanmar", FlagUrl: "https://flagcdn.com/h120/mm.webp" },
//   { Country: "Nepal", FlagUrl: "https://flagcdn.com/h160/np.webp" },
//   { Country: "Pakistan", FlagUrl: "https://flagcdn.com/h120/pk.webp" },
// ];

import Afghanistan from "../../assets/images/countryflags/Afghanistan.png";
import Bangladesh from "../../assets/images/countryflags/Bangladesh.png";
import Bhutan from "../../assets/images/countryflags/Bhutan.png";
import China from "../../assets/images/countryflags/China.png";
import India from "../../assets/images/countryflags/India.png";
import Myanmar from "../../assets/images/countryflags/Myanmar.png";
import Nepal from "../../assets/images/countryflags/Nepal.png";
import Pakistan from "../../assets/images/countryflags/Pakistan.png";

export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const CountryFlags = [
  {
    Country: "Afghanistan",
    FlagUrl: Afghanistan,
  },
  {
    Country: "Bangladesh",
    FlagUrl: Bangladesh,
  },
  { Country: "Bhutan", FlagUrl: Bhutan },
  { Country: "China", FlagUrl: China },
  { Country: "India", FlagUrl: India },
  {
    Country: "Myanmar",
    FlagUrl: Myanmar,
  },
  { Country: "Nepal", FlagUrl: Nepal },
  {
    Country: "Pakistan",
    FlagUrl: Pakistan,
  },
];

// Afghanistan, Bangladesh, Bhutan, China, India, Myanmar, Nepal and Pakistan

export const data_sources_list = [
  "MODIS Surface Reflectance 8-Day (250m)",
  "MODIS Leaf Area Index/FPAR 8-Day",
  "MODIS Vegetation Indices 16-Day (500m)",
  "MODIS Nadir BRDF-Adjusted Reflectance (NBAR) Daily",
  "Landsat Collection 2 Level-1",
  "Landsat Collection 2 Level-2",
  "Sentinel-2 Level-1C",
  "Sentinel-2 Level-2A",
  "Sentinel-1 GRD",
  "Sentinel-1 RTC",
];
export const data_source_bands = [
  {
    source: "Landsat Collection 2 Level-1",
    bands: ["B1", "B2", "B3", "B4", "B5", "B6", "B7"],
  },
  {
    source: "Landsat Collection 2 Level-2",
    bands: [
      "TM_B1",
      "TM_B2",
      "TM_B3",
      "TM_B4",
      "TM_B5",
      "TM_B6",
      "TM_B7",
      "ETM_B1",
      "ETM_B2",
      "ETM_B3",
      "ETM_B4",
      "ETM_B5",
      "ETM_B6",
      "ETM_B7",
      "OLI_B1",
      "OLI_B2",
      "OLI_B3",
      "OLI_B4",
      "OLI_B5",
      "OLI_B6",
      "OLI_B7",
      "TIRS_B10",
    ],
  },
  {
    source: "Sentinel-1 GRD",
    bands: ["VV,VH", "HH,HV", "VV", "VH", "HH", "HV"],
  },
  {
    source: "Sentinel-1 RTC",
    bands: ["VV,VH", "HH,HV", "VV", "VH", "HH", "HV"],
  },
  {
    source: "Sentinel-2 Level-2A",
    bands: [
      "B01",
      "B02",
      "B03",
      "B04",
      "B05",
      "B06",
      "B07",
      "B08",
      "B8A",
      "B09",
      "B10",
      "B11",
      "B12",
    ],
  },
  {
    source: "Sentinel-2 Level-1C",
    bands: [
      "B01",
      "B02",
      "B03",
      "B04",
      "B05",
      "B06",
      "B07",
      "B08",
      "B8A",
      "B09",
      "B10",
      "B11",
      "B12",
    ],
  },
];
export const Projections = [
  "EPSG:4326 WGS 84",
  "EPSG:3857 WGS 84 / Pseudo-Mercator",
  "EPSG:32601 WGS 84 / UTM zone 1N",
  "EPSG:32602 WGS 84 / UTM zone 2N",
  "EPSG:32603 WGS 84 / UTM zone 3N",
  "EPSG:32604 WGS 84 / UTM zone 4N",
  "EPSG:32605 WGS 84 / UTM zone 5N",
  "EPSG:32606 WGS 84 / UTM zone 6N",
  "EPSG:32607 WGS 84 / UTM zone 7N",
  "EPSG:32608 WGS 84 / UTM zone 8N",
  "EPSG:32609 WGS 84 / UTM zone 9N",
  "EPSG:32610 WGS 84 / UTM zone 10N",
  "EPSG:32611 WGS 84 / UTM zone 11N",
  "EPSG:32612 WGS 84 / UTM zone 12N",
  "EPSG:32613 WGS 84 / UTM zone 13N",
  "EPSG:32614 WGS 84 / UTM zone 14N",
  "EPSG:32615 WGS 84 / UTM zone 15N",
];
export const categories = ["water", "ecology", "agriculture"];
export const IndicatorData = [
  {
    title: "Agriculture",
    description:
      "This refers to the practice of cultivating crops and raising livestock for food, fuel, and other products. It includes activities such as planting, harvesting, irrigation, and animal husbandry, and is a critical component of many economies and societies around the world.",
    items: [
      {
        image: agriculture2,
        cardTitle: "Grain output per unit labor force",
        itemDescription:
          "This refers to the amount of grain produced per unit of labor input. It is a measure of agricultural productivity that indicates how efficiently labor is used to produce a given amount of grain.",
        route: "/pages/blogs/author",
      },
      {
        image: agriculture3,
        cardTitle: "Land intensity per unit of output",
        itemDescription:
          "This is a measure of land use efficiency in agriculture. It refers to the amount of land required to produce a unit of output, such as a ton of grain. A lower land intensity per unit of output indicates higher efficiency in land use.",
        route: "/pages/blogs/author",
      },
    ],
  },
  {
    title: "Water",
    description:
      "This refers to the natural sources of water, such as rivers, lakes, groundwater, and precipitation, that are available for human use. Water resources are essential for agriculture, industry, and domestic use, and are a vital component of ecosystems and the environment. Effective management and conservation of water resources are critical for sustainable development.",
    items: [
      {
        image: water2,
        cardTitle: "Area Change rate of surface water body ",
        itemDescription:
          " This refers to the rate at which the size or extent of a surface water body, such as a lake or river, changes over time. The change may be due to natural factors or human activities such as damming, dredging, or pollution.",
        route: "/data-map/radi_water_distribution_yearly",
      },
      {
        image: water3,
        cardTitle: "Proportion of good water quality",
        itemDescription:
          "This is a measure of the percentage of water resources, such as rivers, lakes, and groundwater, that meet certain quality standards for human consumption and other uses. It is an important indicator of the health and sustainability of water resources.",
        route: "/data-map/radi_water_clarity_yearly",
      },
    ],
  },
  {
    title: "Ecological Environment",
    description:
      "内容需要补充内容需要补充充内容需要补充内容需要补充内容需要补充内容需要补充内容需要补充内容需要补充内",
    items: [
      {
        image: eco2,
        cardTitle: "Forest area ratio",
        itemDescription:
          "内容需要补充内容需要补充充内容需要补充内容需要补充内容需要补充内容需要补充内容需要补充内容需要补充内",
        route: "/pages/blogs/author",
      },
      {
        image: eco3,
        cardTitle: "Greening condition in mountain area",
        itemDescription: "内容需要补充内容需要补充",
        route: "/pages/blogs/author",
      },
    ],
  },
];
export const ElementsData = [
  {
    category: "Agriculture",
    items: [
      {
        image: agriculture2,
        cardTitle: "Grain output per unit labor force",
        itemDescription:
          "This refers to the amount of grain produced per unit of labor input. It is a measure of agricultural productivity that indicates how efficiently labor is used to produce a given amount of grain.",
        route: "/pages/blogs/author",
      },
      {
        image: agriculture3,
        cardTitle: "Land intensity per unit of output",
        itemDescription:
          "This is a measure of land use efficiency in agriculture. It refers to the amount of land required to produce a unit of output, such as a ton of grain. A lower land intensity per unit of output indicates higher efficiency in land use.",
        route: "/pages/blogs/author",
      },
    ],
  },
  {
    category: "Water",
    items: [
      {
        image: water2,
        cardTitle: "Water body distribution data",
        itemDescription:
          "Water body distribution data is to describe the spatial distribution of inra-year stable inland water bodies,  including both lakes and rivers in the Hindu Kush Himalaya. Most of the surface water bodies in the region are concentrated in the endorheic basin of Tibetan Plateau. A pixel with a pixel value of 1 is a water pixel, and a pixel value of 0 is a non-water pixel.",
        route: "/data-map/aircas_water_distribution_yearly",
      },
      {
        image: water3,
        cardTitle: "Water clarity data",
        itemDescription:
          "Water clarity is a descriptive term for how deeply visible light penetrates through water. It is one of the most important water quality parameters, and is directly related to the the suspended matter, planktonic algae, and colored dissolved organic matter in the water column. This water clarity data can reflect the comprehensively quality of surface water in the Hindu Kush Himalaya. The higher the pixel value, the higher the water body clarity and the better the water quality.",
        route: "/data-map/aircas_water_clarity_yearly",
      },
    ],
  },
  {
    category: "Ecology",
    items: [
      {
        image: eco2,
        cardTitle: "Forest area ratio",
        itemDescription:
          "Vegetation cover refers to the amount and distribution of plants and other photosynthetic organisms in a given area, typically expressed as a percentage of the total ground surface covered. It includes all types of vegetation, such as trees, shrubs, grasses, and mosses, and provides important habitat and ecosystem services. Vegetation cover is a key indicator of ecological health, and changes in vegetation cover over time can reflect climate change, land use practices, and other environmental factors. Understanding vegetation cover is essential for effective land management, conservation planning, and natural resource monitoring.",
        route: "/pages/blogs/author",
      },
      {
        image: eco3,
        cardTitle: "Greening condition in mountain area",
        itemDescription:
          "Vegetation cover refers to the amount and distribution of plants and other photosynthetic organisms in a given area, typically expressed as a percentage of the total ground surface covered. It includes all types of vegetation, such as trees, shrubs, grasses, and mosses, and provides important habitat and ecosystem services. Vegetation cover is a key indicator of ecological health, and changes in vegetation cover over time can reflect climate change, land use practices, and other environmental factors. Understanding vegetation cover is essential for effective land management, conservation planning, and natural resource monitoring.",
        route: "/pages/blogs/author",
      },
    ],
  },
];
